import React from 'react';
import { motion } from 'framer-motion';

export default function MessageBubble({ message }) {
  const role = message?.role === 'user' ? 'user' : 'assistant';
  const content = message?.content ?? '';
  const isWireframe =
    role === 'assistant' && message?.type === 'wireframe' && message?.image;

  const isValidWireframeSrc = (src) =>
    typeof src === 'string' && src.startsWith('data:image/');

  return (
    <motion.div
      className={`message-row message-row-${role}`}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, ease: 'easeOut' }}
      data-testid={`message-bubble-${role}`}
    >
      {role === 'assistant' && (
        <div className="message-avatar" aria-hidden="true">
          Z
        </div>
      )}
      <div className={`message-bubble message-bubble-${role}`}>
        {content}
        {isWireframe && isValidWireframeSrc(message.image) && (
          <>
            <img
              src={message.image}
              alt="Wireframe sketch"
              className="wireframe-inline-image"
              data-testid="wireframe-inline-image"
            />
            {message.wireframeVersion != null && (
              <div className="wireframe-version-inline">
                v{message.wireframeVersion}
              </div>
            )}
          </>
        )}
      </div>
    </motion.div>
  );
}
